import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';

import Container from 'partials/Container';
import { DesktopCart, MobileCart } from 'partials/shared';
import BookingProgress from 'partials/Booking/BookingProgress';
import { Button } from 'partials/formElements';

import { isMobile } from 'helpers';

import {
    setCartCollapsedValue,
    setBookingProgressCollapsedValue,
    setBookingVisibility,
} from 'store';


const Wrapper = styled.div`
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 1000;

    > .container {
        button {
            position: relative;

            span {
                position: absolute;
                top: -11px;
                right: 10px;
                color: #fff;
                background: ${css.colors.red};
                min-width: 20px;
                display: block;
                height: 20px;
                border-radius: 10px;
                text-align: center;
                line-height: 20px;
                font-size: 14px;
                z-index: 10;
            }

            &.booking-trigger {
                &:hover {
                    background: ${css.colors.red};
                    color: ${css.colors.main};
                }

                &.active {
                    background: ${css.colors.blue};
                    border-color: ${css.colors.blue};
                    color: #fff;
                    cursor: default;

                    &:hover {
                        background: ${css.colors.blue};
                        color: #fff;
                    }

                    @media(max-width: 767px) {
                        display:none;
                    }
                }
            }
            &.cart-trigger {
                &:hover {
                    background: ${css.colors.main};
                    color: #fff!important;
                }

                &.active {
                    background: ${css.colors.blue};
                    border-color: ${css.colors.blue};
                    color: #fff;
                    cursor: default;

                    &:hover {
                        background: ${css.colors.blue};
                        color: #fff!important;
                    }

                    @media(max-width: 767px) {
                        display:none;
                    }
                }
            }
        }
    }
`

class StickyFooter extends Component {

    componentDidUpdate(prevProps) {
        if (this.props.cart.items.length > prevProps.cart.items.length) {
            const countMarker = document.getElementById('cart-count');

            if (countMarker && countMarker.animate) {
                countMarker.animate([
                    { transform: `scale(1)` },
                    { transform: `scale(4)` },
                    { transform: `scale(1)` },
                ], {
                    duration: 1200,
                    easing: 'ease-in-out',
                    fill: 'forwards',
                    iterations: 1,
                });
            }
        }
    }

    _openBooking() {
        this.props.setBookingProgressCollapsedValue(false);
        this.props.setCartCollapsedValue(true);
    }

    _showBookingAdvisorButton() {
        return !this.props.booking.visible && this.props.booking.meetingType && !this.props.checkout.visible;
    }

    _showBookingProcess() {
        return !this.props.checkout.visible && !this.props.booking.progressCollapsed && !(this.props.booking.step >= 5 && this.props.booking.visible);
    }

    _showCart() {
        return !this.props.checkout.visible && !this.props.cart.collapsed && !(this.props.checkout.step >= 4 && this.props.checkout.visible);
    }

    _showMobileCart() {
        return this._showCart() && isMobile();
    }

    _showDesktopCart() {
        return this._showCart() && !isMobile();
    }

    render() {
        const { booking } = this.props;

        return (
            <Wrapper>
                <Container>
                    {this._showBookingAdvisorButton() &&
                        <Button red className={['booking-trigger', !booking.progressCollapsed ? 'active' : ''].join(' ')} onClick={this._openBooking.bind(this)}>
                            Din rådgivingstime
                        </Button>
                    }
                </Container>
                {this._showBookingProcess() && <BookingProgress />}
                {this._showMobileCart() && <MobileCart />}
                {this._showDesktopCart() && <DesktopCart />}
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    cart: state.cart,
    checkout: state.checkout,
    booking: state.bookMeeting,
});

const actions = {
    setCartCollapsedValue,
    setBookingProgressCollapsedValue,
    setBookingVisibility,
}

export default connect(mapStateToProps, actions)(StickyFooter);


// WEBPACK FOOTER //
// ./src/partials/StickyFooter.js